// EventBus
import Vue from 'vue';
const EventBus = new Vue();
Object.freeze(EventBus);
export default EventBus;

const EventName = {
  nav: {
    onNav: 'on-nav',
    onSubNavChange: 'on-subnav-change'
  },
  product: {
    onCompareProductStart: 'on-compare-product-start'
  },
  productDetail: {
    onCompareList: 'on-compare-list',
    onCompareProductFlagEvent: 'on-compare-product-flag-event',
    onCompareProduct: 'on-compare-product',
    onCompareListDeleteOne: 'on-compare-list-delete-one',
    onCompareListDeleteAll: 'on-compare-list-delete-all',
    onCompareCurrentProduct: 'on-compare-current-product',
    onTabCompareCurrentProduct: 'on-tab-compare-current-product',
    onCompareListDeleteCurrent: 'on-compare-list-delete-current'
  }
};
Object.freeze(EventName);

export { EventName };



// WEBPACK FOOTER //
// ./src/utils/EventBus.js